module.exports = __webpack_public_path__ + "images/init/overdue-empty@2x-50baab38a1613ef0f4a147845c61f5b4.png";